import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomerToken, isCustomerLoginSuccess } from '../../../customer/customer';
import { StoreState } from '../../../../store/store.interface';
import { getLoggedInCartQuoteIdMagentoApiCall } from '../api/shop-cart.api';
import { ActionStatus } from '../../../../common/constants/action-status';
import { waitForCustomerLogin } from '../../../../store/store';
import { CheckoutFlow } from '../../../../common/environment';

export const getLoggedInCartQuoteIdMagento = createAsyncThunk(
  'shopCart/createLoggedInCart',
  async (flow: CheckoutFlow | void, thunkAPI) => {
    try {
      await waitForCustomerLogin();
      const state = thunkAPI.getState() as StoreState;
      if (!isCustomerLoginSuccess(state)) {
        throw new Error('Customer not logged in');
      }
      const token = getCustomerToken(state);
      const quoteId = await getLoggedInCartQuoteIdMagentoApiCall(token, flow ?? undefined);
      return quoteId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as StoreState;
      if (
        state.shopCartState.createLoggedInCartQuoteIdMagento.status == ActionStatus.loading ||
        state.shopCartState.createLoggedInCartQuoteIdMagento.status == ActionStatus.succeeded
      ) {
        return false;
      }
      return true;
    },
  }
);
